<template>
  <v-card>
    <v-toolbar dense dark color="primary">
      <v-toolbar-title>Security</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="
        var valueSend = [];
        sendToParentComponent(valueSend)">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <!-- <v-data-table
      v-model="selectedObjectSecurity"
      :headers="headerObjectSecurity"
      :items="dataObjectSecurity"
      item-key="node_skey"
      hide-actions
      class="elevation-1"
    >
      <template slot="headerObjectSecurity" slot-scope="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
          >
          </th>
        </tr>
      </template>
      <template slot="items" slot-scope="props">
        <tr :active="props.selected">
          <td class="text-xs-left">{{ props.item.object_name }}</td>
          <td class="text-xs-left">{{ props.item.object_type }}</td>
          <td><v-select autocomplete
            :items="accessTypeList"
            item-value="code"
            item-text="description"
            v-model="props.item.access_ind">
          </v-select></td>
        </tr>
      </template>
    </v-data-table> -->
    <v-data-table
      v-model="vDataTable.selected"
      :headers="headerObjectSecurity"
      :items="vDataTable.data"
      :page.sync="vDataTable.options.page"
      :itemsPerPage.sync="vDataTable.options.itemsPerPage"
      :options.sync="vDataTable.options"
      :search="vDataTable.search"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="node_skey"
      class="elevation-1">
      <template v-slot:item.access_ind="{ item }">
        <v-autocomplete outlined dense
          single-line
          hide-details
          :items="accessTypeList"
          item-value="code"
          item-text="description"
          @change="setUpdateFlag(item)"
          v-model="item.access_ind">
        </v-autocomplete>
      </template>
    </v-data-table>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        class="mb-2"
        @click="updateObjectSecurity(vDataTable.data[0].object_skey, vDataTable.data[0].access_ind)"
      >
      OK
      </v-btn>
      <v-btn
        color="primary"
        class="mb-2"
        @click="
          var valueSend = [];
          sendToParentComponent(valueSend)"
      >
      Cancel
      </v-btn>
    </v-card-actions>
    <v-tabs slider-color="blue">
      <v-tab ripple>
        User
      </v-tab>
      <v-tab ripple>
        Group
      </v-tab>
      <v-tab-item eager>
        <v-divider></v-divider>
        <v-card class="mb-4">
          <v-card-text class="">
            <NavUserObject ref="userObject"
              :receiveVar="sendVar" @eventReturn="getVarReturn">
            </NavUserObject>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item eager>
        <v-divider></v-divider>
        <v-card class="mb-4">
          <v-card-text class="">
            <NavGroupObject ref="groupObject"
              :receiveVar="sendVar" @eventReturn="getVarReturn">
            </NavGroupObject>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
  import NavUserObject from '@/components/navigation/NavUserObject'
  import NavGroupObject from '@/components/navigation/NavGroupObject'
  export default {
    components: {
      NavUserObject,
      NavGroupObject
    },

    props: ['receiveVar', 'parentComponent'],

    data () {
      return {
        utils: require('@/utils'),
        stringFormat: require('string-format'),
        appName: process.env.VUE_APP_DB_APP_NAME,
        dialog: {
          dialogProgress: false,
          dialogAddEditWindow: false,
        },
        showMenu: false,
        x: 0,
        y: 0,
        vDataTable: {
          search: '',
          selected: [],
          data: [],
          editedIndex: -1,
          editedItem: {
            win_name: '',
            window_comment: ''
          },
          defaultItem: {
            win_name: '',
            window_comment: ''
          },
          options: {
            page: 1,
            itemsPerPage: -1,
            sortBy: [],
            sortDesc: [],
            groupBy: [],
            groupDesc: true,
            multiSort: true,
            // mustSort: true
          },
        },
        sendVar: [],
        accessTypeList: [
              { code: 0, description: 'No Restriction' },
              { code: 10, description: 'Disable' },
              { code: 20, description: 'Invisible' }],
        selectedObjectSecurity: [],
        dataObjectSecurity: [],
        headerObjectSecurity: [
          { text: 'Object', value: 'object_name', align: 'left' },
          { text: 'Object Type', value: 'object_type', align: 'left' },
          { text: 'Access', value: 'access_ind', align: 'left' },
        ],
      }
    },
    created: function () {
    },
    mounted: function () {
    },
    methods: {
      getVarReturn (value) {
        switch (value.childSend) {
        }
        const apiName = process.env.VUE_APP_NAME
        this.retrieveNodeRoute(apiName)
      },
      sendToParentComponent (value) {
        value.childSend = this.$options._componentTag
        this.$emit('eventReturn', value)
      },
      updateObjectSecurity (objectSkey, accessInd) {
        this.axios.post(process.env.VUE_APP_API + '/navigation/updateNodeObject' + process.env.VUE_APP_DATABASE_TYPE, {
          object_skey: objectSkey,
          access_ind: accessInd
        })
          .then(response => {
            if (response.data.isSuccess) {
              var valueSend = []
              this.sendToParentComponent(valueSend)
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
      retrieveComponentObjectSecurity (appSkey, nodeSkey) {
        this.axios.post(process.env.VUE_APP_API + '/navigation/retrieveComponentObjectSecurity' + process.env.VUE_APP_DATABASE_TYPE, {
          app_skey: appSkey,
          node_skey: nodeSkey
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.vDataTable.data = response.data.data
              if (this.vDataTable.data.length >= 1) {
                this.sendVar.objectSkey = this.vDataTable.data[0].object_skey
                var childUserObject = this.$refs.userObject
                childUserObject.retrieveUserObject(this.vDataTable.data[0].object_skey)
                var childGroupObject = this.$refs.groupObject
                childGroupObject.retrieveGroupObject(this.vDataTable.data[0].object_skey)
              }
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
    }
  }
</script>
